let request = require("../js/request.js");

// 登录相关API
let loginApi = {
  // 用户登录
  userLogin: function(data) {
    return request.post("/login", data);
  },

  // 忘记密码
  forgetPassword: function(data) {
    return request.post("/login/forgetPassword", data);
  },

  // 修改密码
  changeUserPassword: function(data) {
    return request.post("/user/changeUserPassword", data);
  },

  // 登录设置
  loginSetting: function(data) {
    return request.post("/user/loginSetting", data);
  },

  //获取基本设置
  getParams: function() {
    return request.post("/Setting/getParams");
  },

  //更新基本设置
  setParams: function(data) {
    return request.post("/Setting/setParams", data);
  },

  //获取平台级员工
  getUser: function() {
    return request.post("/Setting/getUser");
  },

  // 4.0S 编辑/添加短信配置
  SetYdConfig: function(data) {
    return request.post4s("/service/sms/SetYdConfig.json", data);
  },

  // 4.0S 获取短信配置信息
  GetSmsConfig: function(data) {
    return request.post4s("/service/sms/GetSmsConfig.json", data);
  }
};

// 菜单相关API
let navApi = {
  // 获取菜单列表
  getUserAuthList: function() {
    return request.post("/user/getUserAuthList");
  }
};

// 仪表盘相关API
let mapApi = {
  // 获取地区、空间的设备数量
  getSpaceDeviceCount: function(data) {
    return request.post("/appearance/getSpaceDeviceCount", data);
  }
};

// 设备管理相关API
let deviceApi = {
  /* 生产列表 */
  // 手动生成id
  customGenerateId: function(data) {
    return request.post("/production/customGenerateId", data);
  },
 // 生成id
  generateId: function(data) {
    return request.post("/production/generateId", data);
  },

  // 获取未入库列表
  getDeviceNoList: function(data) {
    return request.post("/production/getDeviceNoList", data);
  },

  // 删除id
  deleteId: function(data) {
    return request.post("/production/deleteId", data);
  },

  // 设备id入库/批量入库
  inStock: function(data) {
    return request.post("/production/inStock", data);
  },

  // 获取已入库列表
  getInStockList: function(data) {
    return request.post("/production/getInStockList", data);
  },

  // 入库设备回收/批量回收
  inStockRecycle: function(data) {
    return request.post("/production/inStockRecycle", data);
  },

  // 出库/批量出库
  outStock: function(data) {
    return request.post("/production/outStock", data);
  },

  // 获取已出库列表
  getOutStockList: function(data) {
    return request.post("/production/getOutStockList", data);
  },

  // 获取公司列表
  getCompanyList: function(data) {
    return request.post("/production/getCompanyList", data);
  },

  // 获取日志列表
  getStockLogList: function(data) {
    return request.post("/production/getStockLogList", data);
  },

  // 出库设备回收/批量回收
  outStockRecycle: function(data) {
    return request.post("/production/outStockRecycle", data);
  },

  // 获取设备表格信息
  getBoxInfo: function(data) {
    return request.post("/production/getBoxInfo", data);
  },

  // 配置主板
  configBoard: function(data) {
    return request.post("/production/configBoard", data);
  },

  // 一键开门
  operDoor: function(data) {
    return request.post("/production/operDoor", data);
  },

  // 配置通讯
  configCom: function(data) {
    return request.post("/Production/updateDeviceNoServer", data);
  },

  // 获取设备平板配置
  getAppConfig: function() {
    return request.post("/Production/getAppConfig");
  },

  // 获取设备箱格配置信息
  getDeviceBoxList: function(data) {
    return request.post("/Production/getDeviceBoxList", data);
  },

  // 添加设备箱格配置信息
  addCabinetBox: function(data) {
    return request.post("/Production/addCabinetBox", data);
  },

  // 删除设备箱格配置信息
  deleteCabinetBox: function(data) {
    return request.post("/Production/deleteCabinetBox", data);
  },

  // 更新设备箱格配置信息
  updateCabinetBox: function(data) {
    return request.post("/Production/updateCabinetBox", data);
  },

  // 修改已出库设备信息（单个修改/批量修改）
  updateOutStock: function(data) {
    return request.post("/Production/updateOutStock", data);
  },

  // 设备审核入库
  verifyInStock: function(data) {
    return request.post("/Production/verifyInStock", data);
  },


  /* 协议管理 */
  // 获取协议列表
  getProtocalList: function(data) {
    return request.post("/protocal/getProtocalList", data);
  },

  // 更新（新增/修改）协议
  updateProtocal: function(data) {
    return request.post("/protocal/updateProtocal", data);
  },

  // 修改协议状态
  changeStatus: function(data) {
    return request.post("/protocal/changeStatus", data);
  }
};

// 模板管理相关API
let templateApi = {
  /* 消息模板 */
  // 获取分类列表
  getCategoryList: function() {
    return request.post("/template/getCategoryList");
  },

  // 更新（新增/修改）分类
  updateCategory: function(data) {
    return request.post("/template/updateCategory", data);
  },

  // 获取模板列表
  getTemplateList: function(data) {
    return request.post("/template/getTemplateList", data);
  },

  // 更新（新增/修改）模板
  updateTemplate: function(data) {
    return request.post("/template/updateTemplate", data);
  },

  // 修改模板状态
  changeTemplateStatus: function(data) {
    return request.post("/template/changeTemplateStatus", data);
  },

  // 删除模板
  deleteTemplate: function(data) {
    return request.post("/template/deleteTemplate", data);
  },

  //获取公司列表
  getCompanyList: function() {
    return request.post("/Template/getCompanyList");
  },

  //获取短信发送情况
  getSmsLogByCompany: function(data) {
    return request.post("/Template/getSmsLogByCompany", data);
  },

  //获取公司短信发送情况
  getSmsLogDetailsByCompany: function(data) {
    return request.post("/Template/getSmsLogDetailsByCompany", data);
  }
};

// 系统相关API
let systemApi = {
  /* 员工管理 */
  // 获取员工列表
  getStaffList: function(data) {
    return request.post("/user/getStaffList", data);
  },

  // 更新员工信息(新增/修改)
  updateStaffInfo: function(data) {
    return request.post("/user/updateStaff", data);
  },

  // 修改员工状态
  changeStaffStatus: function(data) {
    return request.post("/user/changeStaffStatus", data);
  },

  // 获取员工权限列表
  getStaffAuthList: function(data) {
    return request.post("/user/getStaffAuthList", data);
  },

  // 新增员工权限
  addStaffAuth: function(data) {
    return request.post("/user/addStaffAuth", data);
  },


  /* 字典设置 */
  // 获取设备列表
  getDeviceList: function(data) {
    return request.post("/ditionary/getDeviceList", data);
  },

  // 更新（添加/修改）设备
  updateDevice: function(data) {
    return request.post("/ditionary/updateDevice", data);
  },

  // 修改设备状态
  changeDeviceStatus: function(data) {
    return request.post("/ditionary/changeDeviceStatus", data);
  },

  
  // 获取设备品牌/api/状态数据列表
  getAllDataList: function(data) {
    return request.post("/ditionary/getAllDataList", data);
  },


  // 更新（添加/修改)设备品牌
  updateDeviceBrand: function(data) {
    return request.post("/ditionary/updateDeviceBrand", data);
  },

  // 删除设备品牌
  deleteDeviceBrand: function(data) {
    return request.post("/ditionary/deleteDeviceBrand", data);
  },

  // 获取待选Api列表
  getSelectApiList: function(data) {
    return request.post("/ditionary/getApiList", data);
  },

  // 添加设备Api
  updateDeviceApi: function(data) {
    return request.post("/ditionary/updateDeviceApi", data);
  },

  // 删除设备Api
  deleteDeviceApi: function(data) {
    return request.post("/ditionary/deleteDeviceApi", data);
  },

  // 修改设备状态类别
  updateDeviceStatus: function(data) {
    return request.post("/ditionary/updateDeviceStatus", data);
  },


  /** 第三方字典 */
  // 获取密钥
  getAccessKey: function(data) {
    return request.post("/ditionary/getAccessKey", data);
  },


  /* 模块管理 */
  // 获取模块列表
  getModuleList: function() {
    return request.post("/module/getModuleList");
  },

  // 更新模块（新增/修改）
  updateModule: function(data) {
    return request.post("/module/addModule", data);
  },

  // 修改模块状态
  changeModuleStatus: function(data) {
    return request.post("/module/changeModuleStatus", data);
  },

  // 修改模块排序
  changeModuleOrder: function(data) {
    return request.post("/module/changeModuleOrder", data);
  },

  // 删除模块
  deleteModule: function(data) {
    return request.post("/module/deleteModule", data);
  },


  /* 第三方应用 */
  // 获取第三方应用列表
  getThirdAppList: function(data) {
    return request.post("/thirdApp/getThirdAppList", data);
  },

  // 更新（修改/删除）第三方应用
  updateThirdApp: function(data) {
    return request.post("/thirdApp/updateThirdApp", data);
  },

  // 改变第三方应用
  changeThirdApp: function(data) {
    return request.post("/thirdApp/changeThirdApp", data);
  },


  /* 日志管理 */
  // 获取日志列表
  getLogList: function(data) {
    return request.post("/log/getLogList", data);
  },


  /* API管理 */
  // 获取API列表
  getApiList: function(data) {
    return request.post("/api/getApiList", data);
  },

  // 更新（添加/修改）API
  updateApi: function(data) {
    return request.post("/api/updateApi", data);
  },

  // 删除API
  deleteApi: function(data) {
    return request.post("/api/deleteApi", data);
  },

  /* 在线升级 */
  //获取更新安装包列表
  selectDevicePackage: function(data) {
    return request.post("/UpdataOnline/selectDevicePackage", data);
  },

  //上传文件
  uploadFile: function(data, option) {
    return request.post("/UpdataOnline/uploadFile", data, option);
  },

  //添加安装包
  addDevicePackage: function(data) {
    return request.post("/UpdataOnline/addDevicePackage", data);
  },

  //获取主板类型和设备类型
  getDeviceParam: function() {
    return request.post("/UpdataOnline/getDeviceParam");
  },

  //主动更新安装包
  addDevicePackageQeueu: function(data) {
    return request.post("/UpdataOnline/addDevicePackageQeueu", data);
  },

  //主动更新安装包
  delUpdate: function(data) {
    return request.post("/UpdataOnline/delete", data);
  },

  //安装包记录列表
  updateLogList: function(data) {
    return request.post("/UpdataOnline/selectDevicePackageRecord", data);
  },

  //安装包设备列表
  updateDeviceOnline: function(data) {
    return request.post("/UpdataOnline/selectQueueDevice", data);
  },


  /** 定时任务 */
  //获取定时任务列表
  getTaskList: function(data) {
    return request.post("/Task/getTaskList", data);
  },

  //添加、修改定时任务
  updateTask: function(data) {
    return request.post("/Task/editTask", data);
  },

  //修改定时任务状态
  changeStatus: function(data) {
    return request.post("/Task/changeStatus", data);
  },


  /** 地址参数设置 */
  // 获取服务器环境列表
  getServerEnvList: function() {
    return request.post("/Server/getServerEnvList");
  },

  // 新增/修改服务器环境
  updateServerEnv: function(data) {
    return request.post("/Server/updateServerEnv", data);
  },

  // 删除服务器环境
  deleteServerEnv: function(data) {
    return request.post("/Server/deleteServerEnv", data);
  }
};

// 客户管理相关API
let clientMApi = {
  // 获取客户信息列表
  getClientList: function(data) {
    return request.post("/client/getClientList", data);
  },

  // 上传图片接口
  uploadFile: function(data) {
    return request.post("/client/uploadFile", data);
  },

  // 更新（新增/修改）客户
  updateClient: function(data) {
    return request.post("/client/updateClient", data);
  },

  // 修改客户状态
  changeClientStatus: function(data) {
    return request.post("/client/changeClientStatus", data);
  },

  // 重置客户密码
  resetClientPassword: function(data) {
    return request.post("/client/resetClientPassword", data);
  },

  // 客户权限列表
  getClientAuthList: function(data) {
    return request.post("/client/getClientAuthList", data);
  },

  // 新增客户权限
  addClientAuth: function(data) {
    return request.post("/client/addClientAuth", data);
  },

  // 获取城市/地区列表
  getAreaList: function(data) {
    return request.commonPost("/common/area", data);
  }
};

// 运维相关API
let maintainApi = {
  /* 客户运维 */
  // 获取公司列表
  getCompanyList: function(data) {
    return request.post("/clientOperation/getCompanyList", data);
  },

  // 更新（添加/修改）联系人信息
  updateContact: function(data) {
    return request.post("/clientOperation/updateContact", data);
  },

  // 获取联系人列表
  getContactList: function(data) {
    return request.post("/clientOperation/getContactList", data);
  },

  // 删除联系人信息
  deleteContact: function(data) {
    return request.post("/clientOperation/deleteContact", data);
  },

  // 更新（添加/修改）安装记录信息
  updateInstallRecord: function(data) {
    return request.post("/clientOperation/updateInstallRecord", data);
  },

  // 获取安装列表
  getInstallRecordList: function(data) {
    return request.post("/clientOperation/getInstallRecordList", data);
  },

  // 删除安装记录信息
  deleteInstallRecord: function(data) {
    return request.post("/clientOperation/deleteInstallRecord", data);
  },

  // 上传文件
  uploadFile: function(data) {
    return request.post("/clientOperation/uploadFile", data);
  },

  // 获取运维记录列表
  getMaintenanceRecordList: function(data) {
    return request.post("/clientOperation/getMaintenanceRecordList", data);
  },

  // 更新（添加）运维记录信息
  updateMaintenanceRecord: function(data) {
    return request.post("/clientOperation/updateMaintenanceRecord", data);
  },


  /* 服务器管理 */
  // 获取服务器列表
  getServerList: function(data) {
    return request.post("/server/getServerList", data);
  },

  // 更新（添加/修改）服务器
  updateServer: function(data) {
    return request.post("/server/updateServer", data);
  },

  // 修改服务器状态
  changeServerState: function(data) {
    return request.post("/server/changeServerState", data);
  },

  // 新增服务器计划
  addServerPlan: function(data) {
    return request.post("/server/addServerPlan", data);
  },

  // 服务器记录列表
  getServerPlanList: function(data) {
    return request.post("/server/getPlanList", data);
  },

  // 修改预存
  modifyFee: function(data) {
    return request.post("/server/modifyFee", data);
  },

  // 获取预存列表
  getFeeList: function(data) {
    return request.post("/server/getFeeList", data);
  },

  // 获取服务器组列表
  getServerCategoryList: function() {
    return request.post("/server/serverCategoryList");
  },

  // 更新（添加/修改）服务器组
  updateServerCategory: function(data) {
    return request.post("/server/updateServerCategory", data);
  },

  // 删除服务器组
  deleteServerCategory: function(data) {
    return request.post("/server/deleteServerCategory", data);
  },

  // 获取网络类型列表
  getServerCategoryNetworkTypeList: function() {
    return request.post("/server/serverCategoryNetworkTypeList");
  },

  // 获取单台服务器信息
  getServerInfo: function(data) {
    return request.post("/server/getServerInfo", data);
  },


  /* 服务器运维 */
  // 获取服务器列表
  getOperationList: function(data) {
    return request.post("/serverOperation/getOperationList", data);
  },

  // 操作
  addOperation: function(data) {
    return request.post("/serverOperation/addOperation", data);
  },

  // 获取服务器运维记录列表
  getServerMaintainRecordList: function(data) {
    return request.post("/serverOperation/getRecordList", data);
  },


  /* 企业套餐 */
  // 获取企业套餐列表
  getPlanList: function(data) {
    return request.post("/companyPlan/getPlanList", data);
  },

  // 修改企业套餐
  updatePlan: function(data) {
    return request.post("/companyPlan/updatePlan", data);
  },

  // 修改企业套餐欠费状态
  changePlanStatus: function(data) {
    return request.post("/companyPlan/changePlanStatus", data);
  },

  // 预存
  prestore: function(data) {
    return request.post("/companyPlan/prestore", data);
  },

  // 获取付费详情列表
  getPayLogList: function(data) {
    return request.post("/companyPlan/getPayLogList", data);
  },

  // 修改支付记录状态
  changePayStatus: function(data) {
    return request.post("/companyPlan/changePayStatus", data);
  },

  // 获取服务器组列表(出库)
  getServerCategoryListOut: function() {
    return request.post("/Production/serverCategoryList");
  },

  // 获取设置用途(出库)
  getDeviceList: function(data) {
    return request.post("/Production/getDeviceList", data);
  }
};

// 公共接口
let commonApi = {
  // 获取页面权限
  getActionRole: function(data) {
    return request.post("/user/getActionRole", data);
  }
};

export {
  loginApi,
  navApi,
  mapApi,
  deviceApi,
  templateApi,
  systemApi,
  clientMApi,
  maintainApi,
  commonApi
};



//////////////////
// WEBPACK FOOTER
// ./static/js/api.js
// module id = null
// module chunks = 